import { Component, Mixins, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import { Debounce } from 'lodash-decorators'
import ProjectUser from '@/views/Authorization/models/projectUser'
import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'
import { minSearchTermLength } from '@/_type/const'
import { PROJECT_USERS_QUERY } from '@/views/Project/gql/queries'
import { PageInfo, Query } from '@/schema'
import { ApolloQueryResult } from '@apollo/client'

@Component({
    components: { ToolbarComponent },
})
export default class UserTable extends Mixins<MixinInterface>() {
    projectUsers: Array<ProjectUser> = []
    infiniteID = +new Date()
    searchTerm = ''
    searching = false
    pageInfo: Maybe<PageInfo> = null

    get minSearchTermLength() {
        return minSearchTermLength
    }

    get canManageUsers() {
        return this.hasPermission(this.currentProjectPermissions, ['authorization.delegate_access'])
    }

    @Watch('currentProjectId', { immediate: true })
    async changeProject() {
        if (!this.currentProjectId) {
            return
        }

        this.searching = true
        this.reset()
    }

    @Watch('searchTerm')
    @Debounce(500)
    handleDebounce() {
        this.searching = true
        this.reset()
    }

    reset() {
        this.projectUsers = []
        this.pageInfo = null
        this.infiniteID = +new Date()
    }

    async searchProjectUsers($state: any) {
        try {
            const variables = {
                projectId: this.currentProjectId,
                searchTerm: this.searchTerm,
            }
            if (this.pageInfo?.hasNextPage) {
                variables['after'] = this.pageInfo.endCursor
            }
            const projectUsersResult: ApolloQueryResult<Query> = await this.$apollo.query({
                query: PROJECT_USERS_QUERY,
                variables,
                fetchPolicy: 'network-only',
            })

            this.pageInfo = projectUsersResult.data?.projectUsers?.pageInfo || null
            projectUsersResult.data?.projectUsers?.nodes?.forEach((node) => {
                // @ts-ignore
                this.projectUsers.push(node)
            })

            if (this.pageInfo?.hasNextPage === false) {
                $state.complete()
            } else {
                $state.loaded()
            }

            this.$emit('input', this.projectUsers)
            this.searching = false
        } catch (error) {
            $state.complete()
            throw error
        }
    }
}
